import { Box, Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material'
import type React from 'react'
import CloseIcon from '@mui/icons-material/Close'

interface AssetDialogProps {
    fileName: string
    url: string
    isOpen: boolean
    handleClose: () => void
}

export const AssetDialog: React.FC<AssetDialogProps> = (props: AssetDialogProps) => {
    return (
        <Dialog open={props.isOpen} onClose={props.handleClose} maxWidth="lg" >
            <Box display="flex" alignItems="center" justifyContent="space-between">
                <DialogTitle>{props.fileName}</DialogTitle>
                <IconButton onClick={props.handleClose}><CloseIcon /></IconButton>
            </Box>
            <DialogContent>
                <Box component="img" display="flex" alignItems="center" width="-webkit-fill-available" src={props.url} alt="background" />
            </DialogContent>
        </Dialog>
    )
}
